export default "__VITE_ASSET__ByV962lJ__"